
import $ from 'jquery';

import BaseVisualControlFactory from 'BaseVisualControlFactory.js';
import constants        from 'Constants.js';
import sequenceService  from 'SequenceService.js';
import ControlModel    from 'ControlModel.js';
import helloWorldView  from 'common-visuals/HelloWorldView.js';


class ControlHelloWorldFactory extends BaseVisualControlFactory {

    constructor () {
        super();
    }

    createView( factoryKey, pos ) {

        const attributes = this.createChildAttributes( factoryKey, pos ) ;
        //adding silent(accessibility) to attributes.
        attributes.silent = false;
        attributes.styleColorText = '~textColor';
        attributes.fontFamily = '~textFont';
        attributes.fontSize = '~textFont';
        attributes.textWeight = '~textFont';
        attributes.textStyle = '~textFont';
        attributes.sharedSettingsTitle = 'Hello World Shared Settings';
        attributes.tabSettingsTitle = 'Hello World Settings';
        attributes.inlineEditable = true;
        attributes.maxChars = '';
        attributes.description = '';

        const view = new helloWorldView( { model: new ControlModel( attributes ),  el: $(constants.FORM_ID),
            pos: pos, factoryKey: factoryKey, id: sequenceService.nextDomId()} );

        return view;
    }

}

const controlHelloWorldFactory = new ControlHelloWorldFactory();

export default controlHelloWorldFactory;
